import { FC } from 'react';
import { AdvertContactDataItemType, useBotDetectorContext } from '@edikk-edikk/country-frontend';
import advertDetailContactItemCss from '../../assets/contacts/contact-item.module.scss';
import { AdvertSocialLink } from '#components/social-link';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  socialLink: AdvertContactDataItemType;
};

const ContactsSocialLink: FC<PropsType> = ({
  socialLink,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();

  return (
    <div className={advertDetailContactItemCss.advertDetailContactItem}>
      <AdvertSocialLink
        socialLink={socialLink}
        buttonAdditionalClassName={advertDetailContactItemCss.advertDetailContactItem__link}
        isAllowLink={isBot || (!isBot && !isDeleted)}
      />
    </div>
  );
};

export { ContactsSocialLink };
